<template>
    <div >

        
        <!-- 1) stage 0 - choose date and ticket -->
        <div v-if="orderStage_n === 0">

            <!-- 1.1) title -->
            <div class="TQ_bg_white TQ_padding_16px TQ_margin_bottom_2px TQ_borderRadius_top TQ_box_shadow TQ_textAlign_initial">
                <div class="TQ_text_28px TQ_margin_bottom_8px TQ_textColor_purple_dark TQ_text_bold ">
                    {{ass_strings.twoWords_orderQuest[ps_langCode_e]}}
                </div>

                <div class="TQ_textColor_green TQ_text_bold TQ_text_14px">
                    {{ass_strings.sentence_canCancelOrder[ps_langCode_e]}}
                </div>
            </div>

            <!-- 1.2) event details-->
            <div class="TQ_padding_16px TQ_margin_bottom_2px TQ_box_shadow TQ_textAlign_initial TQ_bg_gray3" v-if="p_questEvent_c != null">
                <div class="TQ_center TQ_text_20px">
                    <div class="TQ_margin_bottom_4px TQ_text_bold">
                        {{p_questEvent_c.cm_qev_getName_fs(ps_langCode_e)}}
                    </div>
                    <div>
                        {{format_date_YYYY_MM_DD_hh_mm_fs(p_questEvent_c.qev_startingDate_t)}}
                    </div>
                </div>
            </div>

            <!-- 1.3) Ticket && DATE-->
            <div class="TQ_bg_white TQ_padding_16px TQ_margin_bottom_2px TQ_box_shadow">

                <div class="TQ_center">

                    <!-- 2.1) DATE and Hour -->
                    <div v-if="co_choosableDate_b" >

                        <!-- 2.1.1) DATE -->
                        <tq-calendar-small
                                class="TQ_box_shadow"
                                :pb_clickable-mouth-days_an="co_chooseDate_clickableMouthDays_an"
                                :pb_purple-bg-days_ad="[playerSelected_o.calendarDay_d]"
                                :ps_system_lang-code_s="ps_langCode_e"
                                :pe_on-click-day_f="m_chooseDate_selectedDayOfTheMonth_f"
                                :pe_change-month_f="m_chooseDate_setCurrentMonthQuestEvent_f"
                                :pb_forward-month_n="3"
                                :pb_back-months_n="0"
                        />

                        <!-- space -->
                        <div class="TQ_padding_4px"></div>

                        <!-- 2.1.2) HOUR -->
                        <div class="TQ_height_44px">
                            <tq-select class="TQ_fullScreen TQ_center TQ_text_20px"
                                       :style-select="true">

                                <div slot="select" >
                                    <div v-if="playerSelected_o.availableEventDate_t">
                                        <div class="TQ_text_18px">{{format_date_hh_mm_fs(playerSelected_o.availableEventDate_t)}}</div>
                                        <div class="TQ_text_14px TQ_textColor_red">
                                            {{m_chooseDate_availableSpotsText_s(playerSelected_o.availableEventDate_t)}}</div>
                                    </div>
                                    <div v-else class="TQ_padding_4px">
                                        {{ass_strings.twoWords_selectHour[ps_langCode_e]}}
                                    </div>
                                </div>

                                <div slot="options"
                                     v-for="(availableDate_t, index) in m_availableQuestsEventsDates_at(playerSelected_o.calendarDay_d)"
                                     @click="m_chooseDate_selectedQuestEventHour_f(availableDate_t)"
                                     :key="index">
                                    <div class="TQ_text_18px">{{format_date_hh_mm_fs(availableDate_t)}}</div>
                                    <div class="TQ_text_14px TQ_textColor_red">
                                        {{m_chooseDate_availableSpotsText_s(availableDate_t)}}
                                    </div>
                                </div>
                            </tq-select>
                        </div>

                        <!-- space -->
                        <div class="TQ_padding_4px"></div>
                    </div>

                    <!-- 2.2) Ticket-->
                    <div>

                        <!-- 2.2.1) gradualTicket -->
                        <div v-if="co_tickets_gradualTicket_b" >

                            <div class="TQ_textAlign_initial TQ_text_20px TQ_text_bold TQ_margin_bottom_4px TQ_inline">{{ass_strings.threeWords_numberOfPlayers[ps_langCode_e]}}:</div>

                            <div class="TQ_inline TQ_padding_4px"> </div>

                            <input @change="() => {m_stage1_changePlayersToJoinNum_f()}"
                                   class="TQ_center TQ_padding_4px TQ_text_20px TQ_inline TQ_width_52px TQ_input_border"
                                   type="number"
                                   v-model.number="playerSelected_o.playerNum_n"/>

                            <div class="TQ_inline TQ_padding_4px"> </div>

                        </div>

                        <!-- 2.2.2) specificTicket -->
                        <tq-select v-else
                                   class="TQ_fullScreen TQ_border_gray TQ_borderRadius  TQ_padding_4px"
                                   :ps_only-mobile-mode_b="true"
                                   options-width="calc(100vw - 40px)"
                                   max-width="320px">

                            <div  slot="select" class="TQ_padding_4px">

                                <div v-if="playerSelected_o.ticket_c" class="TQ_textAlign_initial">

                                    <div>
                                        <div class="TQ_inline">
                                            <div class="TQ_inline TQ_margin_2px"> {{ass_strings.oneWord_players[ps_langCode_e]}}:</div>
                                            <div class="TQ_text_bold TQ_inline TQ_margin_2px"> {{playerSelected_o.ticket_c.qexa_spots_n}} </div>
                                        </div>,
                                        <div class="TQ_inline">
                                            <div class="TQ_inline TQ_margin_2px"> {{ass_strings.oneWord_cost[ps_langCode_e]}}:</div>
                                            <div class="TQ_text_bold TQ_inline TQ_margin_2px"> {{format_cost(playerSelected_o.ticket_c.qexa_cost_c.c_m_changeCurrency_c(p_system_currentCurrency_e))}}</div>
                                        </div>
                                    </div>

                                    <div class="TQ_text_14px" v-if="playerSelected_o.ticket_c.qexa_description_blc_s[co_displayLangCode_e]">
                                        {{playerSelected_o.ticket_c.qexa_description_blc_s[co_displayLangCode_e]}}
                                    </div>


                                </div>
                                <div v-else class="TQ_text_20px TQ_width_100p TQ_align_initial TQ_textColor_gray">
                                    {{ass_strings.twoWords_selectTicket[ps_langCode_e]}}
                                </div>

                            </div>

                            <div slot="options"
                                 class="TQ_border_bottom TQ_padding_4px"
                                 @click="m_stage1_changePlayersToJoinNum_f(availableTicket)"
                                 :class="{'TQ_bg_gold_lite': playerSelected_o.ticket_c === availableTicket}"
                                 v-for="(availableTicket, index) in co_tickets_availableTickets_ac"
                                 :key="index">

                                <div class="TQ_padding_4px TQ_textAlign_initial TQ_margin_0_8px">

                                    <div >
                                        <div class="TQ_inline">
                                            <div class="TQ_inline TQ_margin_2px"> {{ass_strings.oneWord_players[ps_langCode_e]}}: </div>
                                            <div class="TQ_text_bold TQ_inline TQ_margin_2px"> {{availableTicket.qexa_spots_n}} </div>
                                        </div>,
                                        <div class="TQ_inline">
                                            <div class="TQ_inline TQ_margin_2px"> {{ass_strings.oneWord_cost[ps_langCode_e]}}:</div>
                                            <div class="TQ_text_bold TQ_inline TQ_margin_2px"> {{format_cost(availableTicket.qexa_cost_c.c_m_changeCurrency_c(p_system_currentCurrency_e))}}</div>
                                        </div>
                                    </div>

                                    <div class="TQ_text_14px" v-if="availableTicket.qexa_description_blc_s[co_displayLangCode_e]">
                                        {{availableTicket.qexa_description_blc_s[co_displayLangCode_e]}}
                                    </div>
                                </div>


                            </div>
                        </tq-select>

                    </div>

                    <!-- space -->
                    <div class="TQ_padding_4px"></div>

                </div>

            </div>

            <!-- 1.4) enter discount code -->
            <div class="TQ_bg_white TQ_padding_16px TQ_box_shadow TQ_margin_bottom_2px">
                <div class="TQ_margin_bottom_8px TQ_borderRadius TQ_padding_1px">

                    <!-- have discount -->
                    <div v-if="orderDetails_o.couponId_uid" class="TQ_center TQ_padding_8px TQ_bg_green TQ_text_20px TQ_borderRadius">
                        {{orderDetails_o.discountPercentage_n}}% {{ass_strings.oneWord_discount[ps_langCode_e]}}
                    </div>

                    <!-- dont have discount-->
                    <div v-else >

                        <div class="TQ_grid_col_1frAuto TQ_border_gray TQ_borderRadius">

                            <input class="lc_inputCoupon TQ_grid_verticalCenter TQ_align_initial TQ_width_100p TQ_border_none TQ_padding_8px TQ_borderBox TQ_text_20px TQ_center"
                                   v-model="enteredQuestCoupon_s"
                                   :disabled="loader_couponCode_b"
                                   :placeholder="ass_strings.threeWords_enterDiscountCode[ps_langCode_e]"/>

                            <tq-loader-button class="TQ_padding_4px TQ_grid_verticalCenter  TQ_bg_circle"
                                              :showLoader="loader_couponCode_b">
                                <tq-beacon :p_show-beacon_b="enteredQuestCoupon_s.length > 0" @click.native="m_stage1_checkQuestCoupon_f">
                                    <tq-image class="TQ_width_20px TQ_clickable TQ_margin_top_4px"
                                              :class="!co_direction_ltr_f && 'TQ_rotate180d'"
                                              :pb_src_r="ass_img_send_b"/>
                                </tq-beacon>

                            </tq-loader-button>
                        </div>

                    </div>

                </div>

            </div>

            <!-- 1.5) currency -->
            <div v-if="p_showCurrency_b" class="TQ_bg_white TQ_box_shadow TQ_text_20px TQ_margin_bottom_4px" >
                <div class="TQ_center TQ_grid_col_1fr1fr1fr TQ_direction_ltr ">
                    <div @click="m_stage1_setStoreCurrency_f(currency_n)"
                         v-for="currency_n in enum_costCurrency_n"
                         :class="{'TQ_bg_purple_lite' : currency_n === p_system_currentCurrency_e}"
                         class="TQ_clickable TQ_padding_8px">
                        {{format_costCurrency(currency_n)}}
                    </div>
                </div>

            </div>

            <!-- 1.6) order btn -->
            <div class="TQ_bg_white TQ_padding_16px TQ_box_shadow" :class="{'TQ_borderRadius_bottom' : !pf_showShareBtns_b}">

                <!-- order summery -->
                <div class="TQ_margin_bottom_8px TQ_height_28px">
                    <div v-if="orderDetails_o.cost_c" class="TQ_grid_col_Auto1frAuto ">
                        <div class="TQ_grid_verticalCenter TQ_text_bold TQ_textColor_purple">{{ass_strings.twoWords_totalPayment[ps_langCode_e]}}:</div>
                        <div class="TQ_grid_verticalCenter"></div>
                        <div>

                            <div v-if="orderDetails_o.couponId_uid" class="TQ_text_20px TQ_grid_verticalCenter TQ_textColor_red TQ_text_bold TQ_inline">
                                <div class="TQ_inline">{{format_cost(co_getCurrentCost_n)}}</div>
                                <div class="TQ_padding_4px TQ_inline"></div>
                            </div>

                            <div class="TQ_text_20px TQ_grid_verticalCenter TQ_textColor_purple TQ_inline "
                                 :class="{'TQ_text_lineThrough' : orderDetails_o.couponId_uid}">
                                {{format_cost(orderDetails_o.cost_c)}}
                            </div>

                        </div>
                    </div>

                </div>

                <!-- order btn -->
                <div class="TQ_padding_8px TQ_bg_purple TQ_text_28px TQ_borderRadius TQ_clickable TQ_center TQ_box_shadow2"
                     @click="m_stage1_clickOrderNow_f">
                    {{ass_strings.twoWords_orderNow[ps_langCode_e]}}
                </div>

                <!-- space -->
                <div class="TQ_padding_4px"> </div>

                <!-- agree to creator terms-->
                <!--<div class="TQ_text_14px TQ_center" @click="">-->
                <!--    {{ass_strings.sentence_orderTicketCreatorTerms[ps_langCode_e]}}-->
                <!--    <span class="TQ_link" @click="showPopup_creatorTerms_vb.val=true">{{ass_strings.twoWords_creatorTerms[ps_langCode_e]}}</span>.-->
                <!--</div>-->

            </div>

        </div >

        <!-- 2) stage 1 - choose ticket-->
        <div v-else-if="orderStage_n === 1">

            <!-- back btn -->
            <div class="TQ_bg_purple_dark TQ_box_shadow TQ_margin_bottom_2px TQ_borderRadius_top TQ_padding_8px TQ_direction_ltr TQ_textAlign_initial">

                <div @click="m_stage1a2_orderQuest_backBtn_f" class="TQ_clickable TQ_inline">
                    <tq-image :pb_src_r="ass_img_leftArrow_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                    <div class="TQ_verticalAlignMiddle TQ_inline TQ_margin_2px">
                        {{ass_strings.oneWord_back[ps_langCode_e]}}
                    </div>
                </div>
            </div>

            <!-- player info-->
            <div class="TQ_bg_white TQ_padding_16px TQ_box_shadow TQ_margin_bottom_2px ">

                <!-- email -->
                <div class="TQ_margin_bottom_8px ">
                    <div class=" TQ_text_bold TQ_text_14px">
                        <span class="TQ_textColor_red">*</span>{{ass_strings.oneWord_email[ps_langCode_e]}}
                        <span class="TQ_textColor_red TQ_text_capitalize TQ_text_12px">
                                ({{ass_strings.oneWord_required[ps_langCode_e]}})
                            </span>
                    </div>

                    <tq-error-input
                        class="TQ_width_100p"
                        p_input-class_s="TQ_fullScreen TQ_center TQ_text_16px TQ_padding_8px TQ_border_gray TQ_borderRadius TQ_direction_ltr"
                        :p_input-type_s="enum_inputType.email_s"
                        :p_val_o="orderDetails_o.email_s"
                        :p_placeholder_s="ass_strings.oneWord_email[ps_langCode_e]"
                        :p_error_s="co_checkInput_email_s"
                        :pe_input_f="val => orderDetails_o.email_s = val"/>


                </div>

                <!-- name -->
                <div class="TQ_margin_bottom_8px ">
                    <div class="TQ_text_bold TQ_text_14px">
                        <span class="TQ_textColor_red">*</span>{{ass_strings.oneWord_name[ps_langCode_e]}}
                        <span class="TQ_textColor_red TQ_text_capitalize TQ_text_12px">
                                ({{ass_strings.oneWord_required[ps_langCode_e]}})
                            </span>
                    </div>


                    <tq-error-input
                        class="TQ_width_100p "
                        p_input-class_s="TQ_width_100p TQ_center TQ_text_16px TQ_padding_8px TQ_border_gray TQ_borderRadius TQ_direction_ltr"
                        :p_input-type_s="enum_inputType.text_s"
                        :p_val_o="orderDetails_o.receiptName_s"
                        :p_placeholder_s="ass_strings.oneWord_name[ps_langCode_e]"
                        :p_error_s="co_checkInput_name_s"
                        :pe_input_f="val => orderDetails_o.receiptName_s = val"/>

                </div>

                <!-- phone-->
                <div class="TQ_margin_bottom_8px">
                    <div class="TQ_text_bold  TQ_text_14px">
                        {{ass_strings.oneWord_phone[ps_langCode_e]}}
                    </div>

                    <tq-error-input
                        class="TQ_width_100p "
                        p_input-class_s="TQ_width_100p TQ_center TQ_text_16px TQ_padding_8px TQ_border_gray TQ_borderRadius TQ_direction_ltr"
                        :p_input-type_s="enum_inputType.text_s"
                        :p_val_o="orderDetails_o.phoneNumber_s"
                        p_placeholder_s="050-1234567"
                        :p_error_s="null"
                        :pe_input_f="val => orderDetails_o.phoneNumber_s = val"/>

                </div>

            </div>

            <!-- continue btn-->
            <div class="TQ_bg_white TQ_padding_16px TQ_box_shadow ">


                <div class="TQ_grid_col_auto1fr TQ_grid_gap_8px TQ_margin_bottom_8px ">
                    <tq-checkbox class="TQ_width_20px TQ_height_20px TQ_padding_2px " :p_checked_b="agreeToTos_b" @click.native="agreeToTos_b = !agreeToTos_b"/>
                    <span class="TQ_text_14px TQ_text_capitalize_first_letter">
                        {{ ass_strings.threeWords_iAgreeTo[ps_langCode_e] }}

                        <tq-link class="TQ_link" :p_open-new-tab_b="true" :p_link_s="enum_moveToOptions.terms_termsOfUse">{{ ass_strings.threeWords_termsOfUse[ps_langCode_e] }}</tq-link>,

                        <tq-link class="TQ_link" :p_open-new-tab_b="true" :p_link_s="enum_moveToOptions.terms_privacyPolicy">{{ ass_strings.twoWords_privacyPolicy[ps_langCode_e] }}</tq-link>,
                        {{ ass_strings.oneWord_and[ps_langCode_e] }}

                        <div class="TQ_link TQ_inline" @click="showPopup_creatorTerms_vb.val=true">
                            {{ ass_strings.twoWords_creatorTerms[ps_langCode_e] }}
                        </div>

                    </span>

                </div>

                <div class="TQ_padding_8px TQ_bg_purple_lite TQ_text_20px TQ_borderRadius TQ_clickable TQ_center TQ_box_shadow"
                     @click="m_stage2_clickContinueBtn_f">
                    {{ass_strings.oneWord_Continue[ps_langCode_e]}}
                </div>
            </div>
        </div>

        <!-- 3) stage 2 - enter user details -->
        <div v-else-if="orderStage_n === 2" >

            <!-- back btn -->
            <div class="TQ_bg_purple_dark TQ_box_shadow TQ_margin_bottom_2px TQ_borderRadius_top TQ_padding_8px TQ_direction_ltr TQ_textAlign_initial">

                <div @click="m_stage1a2_orderQuest_backBtn_f" class="TQ_clickable TQ_inline">
                    <tq-image :pb_src_r="ass_img_leftArrow_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                    {{ass_strings.oneWord_back[ps_langCode_e]}}
                </div>
            </div>

            <!-- order details -->
            <div class="TQ_bg_white TQ_box_shadow TQ_margin_bottom_2px TQ_padding_16px" >

                <div class="TQ_grid_col_auto1fr TQ_grid_gap_4px">

                    <div class="TQ_text_bold"       v-if="this.orderDetails_o.eventDate_t"> {{ass_strings.oneWord_date[ps_langCode_e]}}: </div>
                    <div class="TQ_textAlign_end"   v-if="this.orderDetails_o.eventDate_t">{{format_date_YYYY_MM_DD_hh_mm_fs(this.orderDetails_o.eventDate_t)}}</div>

                    <div class="TQ_text_bold"> {{ass_strings.oneWord_players[ps_langCode_e]}}: </div>
                    <div class="TQ_textAlign_end">{{orderDetails_o.spot_n}}</div>

                    <div class="TQ_text_bold"> {{ass_strings.oneWord_price[ps_langCode_e]}}: </div>
                    <div class="TQ_textAlign_end">{{format_cost(co_getCurrentCost_n)}}</div>
                </div>

                <div class="TQ_grid_col_auto1fr TQ_grid_gap_4px TQ_margin_top_16px">

                    <div class="TQ_text_bold"> {{ass_strings.oneWord_email[ps_langCode_e]}} </div>
                    <div class="TQ_textAlign_end">{{orderDetails_o.email_s}}</div>

                    <div class="TQ_text_bold"> {{ass_strings.oneWord_name[ps_langCode_e]}} </div>
                    <div class="TQ_textAlign_end">{{orderDetails_o.receiptName_s}}</div>

                    <div class="TQ_text_bold"       v-if="orderDetails_o.phoneNumber_s">{{ass_strings.twoWords_phoneNumber[ps_langCode_e]}}</div>
                    <div class="TQ_textAlign_end"   v-if="orderDetails_o.phoneNumber_s">{{orderDetails_o.phoneNumber_s}}</div>

                </div>

            </div>

            <!-- iframe icredit -->
            <tq-loader-container :p_show-loader_b="showOrderBtnLoader_b" :p_tq-loader_b="true" class="TQ_center TQ_bg_white TQ_minHeight_400px" :p_absolute-center_b="true">
                <div  class="TQ_bg_white TQ_box_shadow" :class="{'TQ_borderRadius_bottom' : !pf_showShareBtns_b}">

                    <iframe :src="icreditUrl_s" width="100%"
                            :height="co_dom_iframeSize_s"
                            frameBorder="0"
                            class="TQ_bg_white">

                    </iframe>

                </div>
            </tq-loader-container>



        </div>

        <!-- 3) stage 3 - iframe -->
        <div v-else-if="orderStage_n === 3" >

            <tq-loader-container :p_show-loader_b="server_questEvent_c == null" :p_tq-loader_b="true" class="TQ_center" :p_absolute-center_b="true">

                <div v-if="server_questEvent_c" class="TQ_bg_white TQ_borderRadius_top TQ_box_shadow2">
                    <div class="TQ_bg_purple_dark TQ_padding_16px TQ_borderRadius_top TQ_text_24px">
                        {{ass_strings.twoWords_joinQuest[ps_langCode_e]}}
                    </div>

                    <div class="TQ_padding_16px TQ_text_20px TQ_font_SecularOne">

                        <div >
                            {{ass_strings.sentenceGroup_successPayment1[ps_langCode_e]}}.
                        </div>

                        <div class="TQ_margin_8px">
                            {{ass_strings.sentenceGroup_successPayment2[ps_langCode_e]}}
                        </div>

                        <div class="TQ_margin_4px TQ_text_24px">
                            <tq-link :p_link_s="enum_moveToOptions.player_play_entry_ticket + '?ticketId=' + newTicketId_uid" :p_open-new-tab_b="true">
                                {{ass_strings.twoWords_entryLink[ps_langCode_e]}}
                            </tq-link>
                        </div>


                        <!--<div>-->
                        <!--    Return to the play tab and enter the following entry code-->
                        <!--</div>-->

                        <!--<div> {{ass_strings.sentenceGroup_successPayment2[ps_langCode_e]}}:</div>-->

                        <!--<div>-->
                        <!--    <div class="TQ_inline TQ_text_bold TQ_text_20px">{{ass_strings.twoWords_entryCode[ps_langCode_e]}}:</div>-->
                        <!--    <div class="TQ_bg_gold TQ_inline TQ_borderRadius TQ_text_28px TQ_margin_8px TQ_padding_8px TQ_text_bold TQ_clickable "-->
                        <!--         @click="m_copyShortTicketCode_f">-->
                        <!--        {{this.server_questTicket_c.qt_shortKeyId_s}}-->
                        <!--    </div>-->
                        <!--</div>-->

                        <!--<div> {{ass_strings.sentenceGroup_successPayment3[ps_langCode_e]}}! </div>-->
                    </div>

                    <!--<hr>-->

                    <!--<div>-->
                    <!--    <div >{{ass_strings.sentenceGroup_successPayment4[ps_langCode_e]}} </div>-->
                    <!--    <div class="TQ_text_24px TQ_text_selectable TQ_padding_8px">TravelAndQuest.com</div>-->
                    <!--    <div >{{ass_strings.sentenceGroup_successPayment5[ps_langCode_e]}}.</div>-->

                    <!--</div>-->
                </div>
            </tq-loader-container>
        </div>

        <!-- 4) share buttons -->
        <div class="TQ_bg_white TQ_padding_8px TQ_borderRadius_bottom  TQ_box_shadow TQ_margin_top_8px"
             v-if="pf_showShareBtns_b">

            <tq-shares-buttons
                    class="TQ_center"
                    :pb_quest-id_uid="p_questExplore_c.qex_questId_uid"
                    :ps_lang-code_e="ps_langCode_e"
                    :pf_small-mode_b="true"
            />
        </div>

        <!-- 5) popup - creator terms -->
        <tq-popup :show="showPopup_creatorTerms_vb" width="100%" maxWidth="600px"  :show-close-btn="true" padding="0">

            <!-- title -->
            <div class="TQ_center TQ_text_28px TQ_bg_purple_dark TQ_padding_8px">
                {{ass_strings.twoWords_creatorTerms[ps_langCode_e]}}
            </div>

            <!-- creator terms -->
            <div class="TQ_padding_8px" v-html="p_questExplore_c.qex_creatorTerms_byLangCode_c[co_displayLangCode_e].w_body_s"></div>

        </tq-popup>

    </div>
</template>

<script>
import {format_cost_s, format_costCurrency} from "../../../functions/src/shareCode/Share_S_Format";
    import TqSelect from "../basic/TqDropdown";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        enum_fbPath,
        enum_availableTicketsTypes_s,
        enum_costCurrency_n,
        enum_eventsListenersNames,
        enum_iframeMsg,
        enum_inputType,
        enum_moveToOptions,
        enum_loginMethods, enum_directions,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        validator_enum_fb, validator_number_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {
    FB_QuestExplore,
    FB_QuestEvent,
    FB_Cost,
    FB_UserData, FB_QuestExplore_AvailableTickets,
} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqSharesButtons from "../basic/TqSharesButtons";
    import TqCalendarSmall from "../basic/TqCalendarSmall";
    import TqLoaderButton from "../basic2/TqLoaderButton";
    import TqPopup from "../basic/TqPopup";
    import {
        date_getFirstDayOfMonth_t,
        date_getNowDate_resetSeconds_fd, date_newDate_fd,
        date_sameDayMonth_fb,
        date_sameDayWeek_fb,
        date_sameMonth_fb,
        date_sameYear_fb, date_setInterval
    } from "../../scripts/S_Date";
import {
    ass_img_creditCard_b,
    ass_img_flagIsrael_c,
    ass_img_info2_b,
    ass_img_arrow_left_w, ass_img_planetEarth_c,
    ass_img_send_p,
    ass_img_ticket4_p, ass_img_send_b,
} from "../../assets/scripts/Ass_Files";
    import TqStepper from "../basic/TqStepper";
    import {notification_notify, notification_notify2} from "../../scripts/S_Notification";
    import {
        helper_copyStringToClipboard, helper_getDirectionByLangCode_fe,
        helper_getPercentage_n
    } from "../../scripts/S_Helper";
    import {obj_forEach_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import Si_ticketColorful from "../a_smartIcons/si_ticketColorful";
    import {obj_deepCopy_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import {format_date_hh_mm_fs, format_date_YYYY_MM_DD_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {enum_langCodes, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqLoaderContainer from "../basic/TqLoaderContainer";
    import TqBeacon from "../basic2/TqBeacon";
    import TqInputFastDelete from "../basic2/TqInputFastDelete";
    import TqTextarea from "../basic/TqTextarea";
    import {
         server_discountCoupons_getOnce_f,
        server_getPaymentLandingPage_j5_f, server_getQuestTicket_once_f, server_questEvent_once_f,
        server_questEvents_cl_set_f
    } from "@/scripts/Server/S_ServerPre";
    import {serverAuth_currentUserData_update_f, serverAuth_login_guest_fp} from "@/scripts/Server/S_ServerAuth";
    import {eventListener_addEventListenerToObj} from "@/scripts/S_EventListeners";
    import TqImage from "@/components/basic/TqImage";
    import TqErrorInput from "@/components/basic/TqErrorInput";
    import {re_validEmailAddress_fb} from "@/scripts/S_RegularExp";
    import TqCheckbox from "@/components/basic/TqCheckbox";
    import TqLink from "@/components/basic/TqLink";
    import currentWebVersion_o from "../../../currentVersion.json";
    import {store_setStateValue, store_var} from "@/store";
import TqDropdown from "@/components/basic/TqDropdown";
import {helper_getObjIndexInArray_fn} from "../../../functions/src/shareCode/Share_S_Helper";

    export default {
        name: "FcucBuyQuestTicket",
        components: {
            TqDropdown,
            TqLink,
            TqCheckbox,
            TqErrorInput,
            TqImage,
            TqTextarea,
            TqInputFastDelete,
            TqBeacon,
            TqLoaderContainer,
            TqOnTopContainer,
            Si_ticketColorful,
            TqStepper,
            TqPopup,
            TqLoaderButton,
            TqCalendarSmall,
            TqSharesButtons,
            TqSelect
        },
        props:{
            // basic
            p_questExplore_c : {
                require : true,
                type: FB_QuestExplore
            },
            p_questEvent_c:{
                type: FB_QuestEvent
            },
            p_currentUserData_c:{
                type: FB_UserData
            },
            p_playersNum_n:{
                type: Number,
            },
            p_couponCode_n:{
                type: String,
            },
            p_showCurrency_b:{
                type: Boolean,
                default : true
            },

            ps_screenSize_e : {
                type: Number,
                default: enum_screenSizesOptions_n.mobile,
                validator(num_e){
                    return validator_enum_fb(enum_screenSizesOptions_n, num_e)
                }
            },
            ps_langCode_e:{
                type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_system_currentCurrency_e:{
                type: Number,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_costCurrency_n, val)
                }
            },
            p_store_agentId_uid:{
                type: String,
            },

            // flags
            pf_showShareBtns_b:{
                type:Boolean,
                default: false
            },

        },
        data(){
            return {

                orderStage_n : 0,  // 0 -order, 1- receipt name, 2 - payment details, 3 - ticketId_uid
                showReceiptChooseNameSection    : false,
                icreditUrl_s                    : null,

                enteredQuestCoupon_s        : "",
                agreeToTos_b: false,

                showPopup_creatorTerms_vb   : {val : null},
                showOrderBtnLoader_b        : false,
                loader_couponCode_b         : false,

                playerSelected_o:{
                    calendarCurrentMonth_d : null,
                    calendarDay_d : null,
                    availableEventDate_t : null,
                    ticket_c: null,
                    questEvents_byDateTime_ac : {},
                    playerNum_n               : 0
                },

                orderDetails_o : {
                    spot_n                  : 0,
                    cost_c                  : new FB_Cost({c_value_n : 0, c_currency_e : this.p_system_currentCurrency_e}),
                    eventDate_t             : null,
                    receiptName_s           : this.p_currentUserData_c ? this.p_currentUserData_c.ud_name_s : '',
                    phoneNumber_s           : '',
                    email_s                 : this.p_currentUserData_c ? this.p_currentUserData_c.ud_email_s : '',
                    eventId_uid             : null,
                    discountPercentage_n    : 0,
                    couponId_uid            : null
                },

                newTicketId_uid : undefined,
                server_questTicket_c : undefined,
                server_questEvent_c : undefined,

                // imports
                format_costCurrency             : format_costCurrency,
                format_cost                     : format_cost_s,
                format_date_hh_mm_fs            : format_date_hh_mm_fs,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                local_currentWebVersion_o   : currentWebVersion_o,

                ass_strings                     : ass_strings,

                ass_img_planetEarth_c           : ass_img_planetEarth_c,
                ass_img_flagIsrael_c            : ass_img_flagIsrael_c,
                ass_img_creditCard_b            : ass_img_creditCard_b,
                ass_img_leftArrow_w             : ass_img_arrow_left_w,
                ass_img_ticket4_p               : ass_img_ticket4_p,
                ass_img_send_b                    : ass_img_send_b,
                ass_img_info2_b                 : ass_img_info2_b,

                enum_availableTicketsTypes_s    : enum_availableTicketsTypes_s,
                enum_moveToOptions              : enum_moveToOptions,
                enum_inputType                  : enum_inputType,
                enum_costCurrency_n             : enum_costCurrency_n,
            }
        },
        computed : {


            co_checkInput_email_s(){
                if ( this.orderDetails_o.email_s == null || !re_validEmailAddress_fb(this.orderDetails_o.email_s)) {
                    return ass_strings.fourWords_emailAddressIsntValid[this.ps_langCode_e]
                }
                return null
            },
            co_checkInput_name_s(){

                if(this.co_checkInput_email_s){
                    return null
                }

                if ( this.orderDetails_o.receiptName_s == null || this.orderDetails_o.receiptName_s.length < 3) {
                    return ass_strings.sentence_inputErrorUsername3Letters[this.ps_langCode_e]
                }
                return null
            },

            co_direction_ltr_f(){
                return helper_getDirectionByLangCode_fe(this.ps_langCode_e) === enum_directions.ltr
            },

            // chooseDate
            co_choosableDate_b(){
                return this.p_questExplore_c.qex_metadata_c.qexm_playerChooseEvent_b
                    && this.p_questEvent_c == null
            },
            co_chooseDate_clickableMouthDays_an(){

                return this.co_chooseDate_availableDaysOfMouth_an

            },
            co_chooseDate_availableDaysOfMouth_an(){

                if(this.playerSelected_o.calendarCurrentMonth_d == null){
                    return []
                }

                let ans_an = []
                // for every day of the month
                let currentDate_d = date_newDate_fd(this.playerSelected_o.calendarCurrentMonth_d.getTime())
                // currentDate_d.setDate(1)
                let currentMonth_n = currentDate_d.getMonth()
                while(currentMonth_n === currentDate_d.getMonth()){


                    if(this.m_availableQuestsEventsDates_at(currentDate_d).length > 0 ){
                        ans_an.push(currentDate_d.getDate())
                    }

                    currentDate_d.setDate(currentDate_d.getDate() + 1)
                }

                return ans_an
            },

            // tickets
            co_tickets_gradualTicket_b(){
                return this.p_questExplore_c.qex_metadata_c.qexm_availableTicketsType_e === enum_availableTicketsTypes_s.gradualTicket
            },
            co_tickets_availableTickets_ac(){

                if(!this.p_questExplore_c.qex_metadata_c.qexm_playerChooseEvent_b){
                    return this.p_questExplore_c.qex_availableTickets_ac
                }

                // user didnt select date
                if(this.playerSelected_o.availableEventDate_t == null){
                    return []
                }

                let questEvent_ac = this.playerSelected_o.questEvents_byDateTime_ac[this.playerSelected_o.availableEventDate_t]

                let maxSpotsLeft_n
                if(questEvent_ac == null){
                    maxSpotsLeft_n = this.p_questExplore_c.qex_maxPlayersNum_n
                }else{
                    maxSpotsLeft_n = this.p_questExplore_c.qex_maxPlayersNum_n - questEvent_ac[0].qev_playersNum_n
                }

                return this.p_questExplore_c.qex_availableTickets_ac.filter(
                    availableTicket_c => {
                        return availableTicket_c.qexa_spots_n <= maxSpotsLeft_n
                    })
            },

            // others
            co_getCurrentCost_n(){

                return new FB_Cost({
                    c_value_n       : helper_getPercentage_n(this.orderDetails_o.cost_c.c_value_n, 100-this.orderDetails_o.discountPercentage_n),
                    c_currency_e    : this.orderDetails_o.cost_c.c_currency_e,
                })
            },
            co_dom_iframeSize_s(){
                if(this.ps_screenSize_e === enum_screenSizesOptions_n.mobile){
                    return '610px'
                } else{
                    return '570px'
                }
            },

            co_eachWeekOneEvent_b(){
                return !this.co_choosableDate_b && this.p_questExplore_c.qex_metadata_c.qexm_oneEventEachMonth_b
            },
            co_displayLangCode_e(){
                return this.p_questExplore_c.cm_qex_getDisplayLang_fe(this.ps_langCode_e)
            }

        },
        methods:{

            // chooseDate
            m_chooseDate_setCurrentMonthQuestEvent_f(currentMonth_d){

                this.playerSelected_o.calendarCurrentMonth_d = currentMonth_d

                // get quest events of current month
                let currentMonthFirstDay_d = currentMonth_d
                currentMonthFirstDay_d.setDate(1)
                currentMonthFirstDay_d.setHours(0)
                currentMonthFirstDay_d.setMinutes(0)
                let nextMonthFirstDay_d = date_newDate_fd(currentMonthFirstDay_d)
                nextMonthFirstDay_d.setMonth(nextMonthFirstDay_d.getMonth() + 1)

                // 3) get quest events
                server_questEvents_cl_set_f(
                    this.$options.name,
                    this.p_questExplore_c.qex_questType_e,
                    this.p_questExplore_c.qex_questId_uid,
                    currentMonthFirstDay_d.getTime(),
                    nextMonthFirstDay_d.getTime(),
                    (questEvent_c)=> {
                        if(this.playerSelected_o.questEvents_byDateTime_ac[questEvent_c.qev_startingDate_t] == null){
                            this.$set(this.playerSelected_o.questEvents_byDateTime_ac, questEvent_c.qev_startingDate_t, [])
                        }
                        let index_n = helper_getObjIndexInArray_fn(
                            this.playerSelected_o.questEvents_byDateTime_ac[questEvent_c.qev_startingDate_t],
                            enum_fbPath.qev_eventId_uid,
                            questEvent_c.qev_eventId_uid
                        )
                        if (index_n < 0){
                            this.playerSelected_o.questEvents_byDateTime_ac[questEvent_c.qev_startingDate_t].push(questEvent_c)
                        }else{
                            this.playerSelected_o.questEvents_byDateTime_ac[questEvent_c.qev_startingDate_t].splice(index_n, 1, questEvent_c)
                        }
                    },
                )
            },
            m_chooseDate_selectedDayOfTheMonth_f(date_d){

                this.playerSelected_o.availableEventDate_t = null
                this.playerSelected_o.ticket_c = null
                this.playerSelected_o.calendarDay_d = date_d

            },
            m_chooseDate_selectedQuestEventHour_f(availableDate_t){

                this.playerSelected_o.ticket_c = null
                this.playerSelected_o.availableEventDate_t = availableDate_t

            },
            m_chooseDate_availableSpotsText_s(availableDate_t){

                let spotsLeft_n;

                if(this.playerSelected_o.questEvents_byDateTime_ac[availableDate_t]){
                    spotsLeft_n = this.p_questExplore_c.qex_maxPlayersNum_n - this.playerSelected_o.questEvents_byDateTime_ac[availableDate_t][0].qev_playersNum_n
                }else{
                    spotsLeft_n = this.p_questExplore_c.qex_maxPlayersNum_n
                }

                return `${spotsLeft_n}
                        ${ass_strings.oneWord_of[this.ps_langCode_e]}
                        ${this.p_questExplore_c.qex_maxPlayersNum_n}
                        ${ass_strings.twoWords_spotsLeft[this.ps_langCode_e]}`
            },
            m_availableQuestsEventsDates_at(date_d){

                if(date_d == null){return []}

                let ans = []
                let copy_questEvents_byDateTime_ac = obj_deepCopy_f(this.playerSelected_o.questEvents_byDateTime_ac)


                this.p_questExplore_c.qex_availableDates_at.forEach(availableDate_t => {

                    if(date_sameDayWeek_fb(availableDate_t, date_d.getTime())){

                        let hourAndMinutes_d = date_newDate_fd(availableDate_t)
                        let availableDate_d = new Date(date_d.getFullYear(),date_d.getMonth(), date_d.getDate(), hourAndMinutes_d.getHours(), hourAndMinutes_d.getMinutes())

                        // if event not exist
                        if(copy_questEvents_byDateTime_ac[availableDate_d.getTime()] == null){
                            ans.push(availableDate_d.getTime())
                        }

                        // if there are more places
                        else if(copy_questEvents_byDateTime_ac[availableDate_d.getTime()][0].qev_playersNum_n < this.p_questExplore_c.qex_maxPlayersNum_n){
                            delete copy_questEvents_byDateTime_ac[availableDate_d.getTime()]
                            ans.push(availableDate_d.getTime())
                        }
                    }
                })

                obj_forEach_f(copy_questEvents_byDateTime_ac, (questEvent_ac)=>{
                    let sameYear_b      = date_sameYear_fb(questEvent_ac[0].qev_startingDate_t, date_d.getTime())
                    let sameMonth_b     = date_sameMonth_fb(questEvent_ac[0].qev_startingDate_t, date_d.getTime())
                    let sameDayMonth_b  = date_sameDayMonth_fb(questEvent_ac[0].qev_startingDate_t, date_d.getTime())

                    if(sameYear_b && sameMonth_b && sameDayMonth_b){
                        if(questEvent_ac[0].qev_playersNum_n < this.p_questExplore_c.qex_maxPlayersNum_n) {
                            ans.push(questEvent_ac[0].qev_startingDate_t)
                        }
                    }
                })

                ans.sort()

                return ans
            },

            // stage 1
            m_stage1_changePlayersToJoinNum_f(availableTicket_c){

                // safe gard
                if(this.playerSelected_o.playerNum_n < 0){
                    this.playerSelected_o.playerNum_n = 0
                }

                // calculate ticket from playerNum_n
                if(availableTicket_c == null){
                    let selectedAvailableTicket_c = this.p_questExplore_c.qex_availableTickets_ac[0]

                    this.p_questExplore_c.qex_availableTickets_ac.forEach(availableTicket_c => {
                        if(selectedAvailableTicket_c == null ||
                            selectedAvailableTicket_c.qexa_spots_n < availableTicket_c.qexa_spots_n && availableTicket_c.qexa_spots_n <= this.playerSelected_o.playerNum_n){
                            selectedAvailableTicket_c = availableTicket_c
                        }
                    })

                    let oneEntryCostValue_n = (selectedAvailableTicket_c.qexa_cost_c.c_m_changeCurrency_c(this.p_system_currentCurrency_e).c_value_n / selectedAvailableTicket_c.qexa_spots_n)

                    availableTicket_c = new FB_QuestExplore_AvailableTickets({
                        qexa_spots_n : this.playerSelected_o.playerNum_n,
                        qexa_cost_c : new FB_Cost({
                            c_value_n: oneEntryCostValue_n * this.playerSelected_o.playerNum_n,
                            c_currency_e: this.p_system_currentCurrency_e
                            })
                    })

                }

                // update
                this.playerSelected_o.ticket_c = availableTicket_c
                this.orderDetails_o.spot_n = availableTicket_c.qexa_spots_n
                this.orderDetails_o.cost_c = availableTicket_c.qexa_cost_c

            },
            m_stage1_checkQuestCoupon_f(){

                this.loader_couponCode_b = true

                server_discountCoupons_getOnce_f(this.p_questExplore_c.qex_questType_e, this.p_questExplore_c.qex_questId_uid, this.enteredQuestCoupon_s, (questDiscountCoupon_c)=>{

                    this.loader_couponCode_b = false

                    if(questDiscountCoupon_c && questDiscountCoupon_c.qdc_active_b){
                        this.orderDetails_o.discountPercentage_n = questDiscountCoupon_c.qdc_discountPercentage_n
                        this.orderDetails_o.couponId_uid = questDiscountCoupon_c.qdc_couponId_uid
                    }else{
                        notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_discountCouponNotExist)
                        this.enteredQuestCoupon_s = ""
                        this.orderDetails_o.discountPercentage_n = 0
                        this.orderDetails_o.couponId_uid = null
                    }


                })

            },
            m_stage1_clickOrderNow_f(){

                if(this.orderDetails_o.spot_n <= 0){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_chooseTicketMsg)
                    return
                }

                this.orderStage_n++;
            },
            m_stage1_setStoreCurrency_f(currency_e){
                store_setStateValue(store_var.system_currency, currency_e)
            },

            // stage 2
            m_stage2_clickContinueBtn_f(){


                // 1) check selected date
                if(this.co_choosableDate_b && this.playerSelected_o.availableEventDate_t == null ){
                    notification_notify(ass_strings.oneWord_notice, ass_strings.sentence_chooseDateAndHour)
                    return
                }

                // 2) check selected ticket
                if(this.orderDetails_o.receiptName_s.length <= 0){
                    notification_notify(ass_strings.oneWord_notice, ass_strings.sentence_pleaseFillName)
                    return
                }

                // 3) dont choose date
                if(this.co_eachWeekOneEvent_b){
                    this.orderDetails_o.eventDate_t = date_getFirstDayOfMonth_t()
                    this.orderDetails_o.eventId_uid = this.playerSelected_o.questEvents_byDateTime_ac[this.orderDetails_o.eventDate_t] ? this.playerSelected_o.questEvents_byDateTime_ac[this.orderDetails_o.eventDate_t][0].qev_eventId_uid : null
                }


                // 4) check email
                if(this.co_checkInput_email_s){
                    notification_notify2({title_s: ass_strings.oneWord_notice[this.ps_langCode_e], text_s : this.co_checkInput_email_s})
                    return
                }

                // 5) check username
                if(this.co_checkInput_name_s){
                    notification_notify2({title_s: ass_strings.oneWord_notice[this.ps_langCode_e], text_s : this.co_checkInput_name_s})
                    return
                }

                // 5) check username
                if(!this.agreeToTos_b){
                    notification_notify2({title_s: ass_strings.oneWord_notice[this.ps_langCode_e], text_s : ass_strings.sentence_pleaseApproveTheTerms[this.ps_langCode_e]})
                    return
                }


                this.showOrderBtnLoader_b = true
                this.orderStage_n = 2
                this.m_stage2_clickContinueBtn_refreshEventDateAndEventId_f()


                if(this.p_currentUserData_c != null){
                    this.m_stage2_clickContinueBtn_order_f(this.p_currentUserData_c)
                }else{

                    serverAuth_login_guest_fp()
                        .then( (fbAuth_c) => {

                            let newUserData_c = new FB_UserData({
                                ud_userId_uid: fbAuth_c.fa_userId_uid,
                                ud_name_s: this.orderDetails_o.receiptName_s,
                                ud_phone_s: this.orderDetails_o.phoneNumber_s,
                                ud_email_s: this.orderDetails_o.email_s,
                                ud_avatar_c: null,
                                ud_loginMethods_ae : [enum_loginMethods.guest],
                                ud_approveCooliesPolicyVersion_s : this.local_currentWebVersion_o.cookiesVersion,
                                ud_approveTermsOfUseVersion_s : this.local_currentWebVersion_o.termsOfUseVersion,
                            })

                            serverAuth_currentUserData_update_f(newUserData_c, () => {

                                this.m_stage2_clickContinueBtn_order_f(newUserData_c)
                            })


                        })
                }
            },
            m_stage2_clickContinueBtn_refreshEventDateAndEventId_f() {

                // 1) creator
                if(this.p_questEvent_c != null){
                    this.orderDetails_o.eventDate_t = this.p_questEvent_c.qev_startingDate_t
                    this.orderDetails_o.eventId_uid = this.p_questEvent_c.qev_eventId_uid

                    // 2) player
                }else{

                    // 2.1) with StartingDate
                    if(this.co_choosableDate_b){
                        this.orderDetails_o.eventDate_t = this.playerSelected_o.availableEventDate_t;

                        // 2.2) without StartingDate
                    }else{
                        this.orderDetails_o.eventDate_t = date_getNowDate_resetSeconds_fd().getTime()
                    }

                    if(this.playerSelected_o.questEvents_byDateTime_ac[this.orderDetails_o.eventDate_t]){
                        this.orderDetails_o.eventId_uid = this.playerSelected_o.questEvents_byDateTime_ac[this.orderDetails_o.eventDate_t][0].qev_eventId_uid
                    }

                }

            },
            m_stage2_clickContinueBtn_order_f(userData_c) {

                server_getPaymentLandingPage_j5_f({
                    questId_uid             : this.p_questExplore_c.qex_questId_uid,
                    questName_s             : this.p_questExplore_c.cm_qex_getName_fs(this.ps_langCode_e),
                    spots_n                 : this.orderDetails_o.spot_n,
                    cost_c                  : this.orderDetails_o.cost_c,
                    startingDate_t          : this.orderDetails_o.eventDate_t,
                    customerName_s          : this.orderDetails_o.receiptName_s,
                    phoneNumber_s           : this.orderDetails_o.phoneNumber_s,
                    eventId_uid             : this.orderDetails_o.eventId_uid, // could be null
                    couponId_uid            : this.orderDetails_o.couponId_uid,
                    discountPercentage_n    : this.orderDetails_o.discountPercentage_n,
                    langCode_e              : this.ps_langCode_e,
                    agentId_uid             : this.p_store_agentId_uid,

                    currentUserData_c       : userData_c,

                    cb_f : (ans_o, ticketId_uid) =>{
                        this.showOrderBtnLoader_b = false
                        this.newTicketId_uid = ticketId_uid
                        this.icreditUrl_s = ans_o.URL
                    },
                    errorCb_f: () => {
                        notification_notify(ass_strings.oneWord_notice, ass_strings.threeWords_somethingWentWrong)
                        this.showOrderBtnLoader_b = false
                        this.orderStage_n--;
                    }
                })
            },

            // stage3
            m_stage3_getQuestTicketAndEvent_f(){

                date_setInterval(this.$options.name + '_1', 1000, 30000, ()=>{
                        if(this.server_questTicket_c != null){return}

                        server_getQuestTicket_once_f(this.newTicketId_uid, false, (questTicket_c) => {
                            this.server_questTicket_c = questTicket_c

                            // get quest event
                            date_setInterval(this.$options.name + "_2", 1000, 30000, ()=>{
                                    if(this.server_questEvent_c != null){return}

                                    server_questEvent_once_f(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid, questTicket_c.qt_eventId_uid, false, (questEvent_c) =>{
                                        this.server_questEvent_c = questEvent_c
                                    })
                                },
                                () => {})
                        })
                    },
                    () => {})
            },
            m_copyShortTicketCode_f(){
                helper_copyStringToClipboard(this.questTicket_c.qt_shortKeyId_s)
                notification_notify(ass_strings.threeWords_entryCodeCopied)
            },

            // stage 2 and 3
            m_stage1a2_orderQuest_backBtn_f(){
                this.icreditUrl_s=null
                this.showOrderBtnLoader_b = false
                this.orderStage_n--;
            },

        },
        watch:{
            p_system_currentCurrency_e: {
                  handler(){
                      if(this.playerSelected_o.ticket_c){
                          this.orderDetails_o.cost_c = this.playerSelected_o.ticket_c.qexa_cost_c.c_m_changeCurrency_c(this.p_system_currentCurrency_e)
                      }else{
                          this.orderDetails_o.cost_c.c_currency_e = this.p_system_currentCurrency_e
                      }
                  }
            }
        },
        mounted(){

            if(this.co_eachWeekOneEvent_b){
                this.m_chooseDate_setCurrentMonthQuestEvent_f(date_newDate_fd())
            }

            if(this.p_couponCode_n){
                this.enteredQuestCoupon_s = this.p_couponCode_n
                this.m_stage1_checkQuestCoupon_f(() => {
                    if(validator_number_fb(this.p_playersNum_n)){
                        this.orderDetails_o.spot_n = this.p_playersNum_n
                        this.m_stage1_changePlayersToJoinNum_f()
                    }
                })
            }

            // listener for iframe Icredit
            eventListener_addEventListenerToObj(window, enum_eventsListenersNames.message, false, this.$options.name, (event) => {
                let msg_s = event.data.msg

                if(msg_s == null){
                    return
                }
                this.icreditUrl_s = null
                this.orderStage_n++


                if(msg_s === enum_iframeMsg.failed_s){
                    this.ticketId_uid = null
                    notification_notify2({
                        title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                        text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})
                }else if(msg_s === enum_iframeMsg.success_s){
                    this.m_stage3_getQuestTicketAndEvent_f()
                }

            })

        },
        activated(){

            if(this.co_eachWeekOneEvent_b){
                this.m_chooseDate_setCurrentMonthQuestEvent_f(date_newDate_fd())
            }



        },
        deactivated(){
            this.icreditUrl_s = null
            this.showPopup_creatorTerms_vb = {val : null}

            this.playerSelected_o = {
                calendarCurrentMonth_d      : null,
                calendarDay_d               : null,
                availableEventDate_t        : null,
                ticket_c                    : null,
                questEvents_byDateTime_ac   : {},
            }

            this.showOrderBtnLoader_b = false

        },
    }

</script>

<style scoped lang="scss">
    .lc_inputCoupon:focus{
        outline: none;
    }
</style>
